// @flow

import type { State } from '../travelerInfo';
import type { Action } from '../../state';

type ActionData = {|
  oneWayDate: ?string, // YYYY-MM-DD or ""
  departureDate: ?string, // YYYY-MM-DD or ""
  returnDate: ?string, // YYYY-MM-DD or ""
|};

export type FlightsTravelerInfo = {|
  oneWayDate: ?string, // YYYY-MM-DD or ""
  departureDate: ?string, // YYYY-MM-DD or ""
  returnDate: ?string, // YYYY-MM-DD or ""
|};

const SET_FLIGHTS_TRAVELLER_INFO = 'SET_FLIGHTS_TRAVELLER_INFO';

/**
 * Update the date in FlightsTravelerInfo.
 */
export const setFlightsTravelerInfo = (
  oneWayDate: ?string,
  departureDate: ?string,
  returnDate: ?string,
) => ({
  type: SET_FLIGHTS_TRAVELLER_INFO,
  oneWayDate,
  departureDate,
  returnDate,
});

const handleSetFlightsTravelerInfo = (state: State, action: ActionData) => {
  if (!state.flights) {
    return {
      ...state,
      flights: {
        oneWayDate: action.oneWayDate,
        departureDate: action.departureDate,
        returnDate: action.departureDate,
      },
    };
  }

  const flights = { ...state.flights };
  if (action.oneWayDate !== undefined) {
    flights.oneWayDate = action.oneWayDate;
  }
  if (action.departureDate !== undefined && action.returnDate !== undefined) {
    flights.departureDate = action.departureDate;
    flights.returnDate = action.returnDate;
  }

  return { ...state, flights };
};

const defaultState = Object.freeze({});

/**
 * Changes state depending on the action's type
 * @param state  global redux store State - defined in state.jsx, contains travelerInfo, which has FlightsTravelerInfo
 * @param action  global redux store Action - defined in state.jsx
 * @returns updated state
 */
export default (state: State = defaultState, action: Action): State => {
  switch (action.type) {
    case SET_FLIGHTS_TRAVELLER_INFO:
      return handleSetFlightsTravelerInfo(state, action);
    default:
      return state;
  }
};
